import type { MailRibbonGroupId, HelpRibbonGroupId, RibbonControlId } from "owa-ribbon-ids";
import type { MailRibbonGroup } from "../types/mailRibbonGroup";

export function getRibbonSectionContents(groupId: MailRibbonGroupId | HelpRibbonGroupId, controlIds: RibbonControlId[], hasOwnOverflow: boolean = false): MailRibbonGroup {
    return {
        groupId,
        groupName: undefined,
        controlIds,
        hasOwnOverflow,
    };
}
